import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  pulse?: boolean;
}
export function Button({
  children,
  className = '',
  pulse = false,
  ...props
}: ButtonProps) {
  const buttonContent = <button className={`w-full sm:w-auto bg-brand-gold hover:bg-brand-goldHover text-black font-bold py-4 px-8 rounded-full shadow-[0_4px_20px_rgba(245,166,35,0.4)] hover:shadow-[0_6px_25px_rgba(245,166,35,0.6)] hover:-translate-y-1 transition-all duration-300 text-lg sm:text-xl md:text-2xl min-h-[48px] ${className}`} {...props} data-id="element-6">
      {children}
    </button>;
  if (pulse) {
    return <motion.div animate={{
      scale: [1, 1.03, 1]
    }} transition={{
      repeat: Infinity,
      duration: 2,
      ease: 'easeInOut'
    }} className="inline-block w-full sm:w-auto" data-id="element-7">
        {buttonContent}
      </motion.div>;
  }
  return buttonContent;
}